export default "__VITE_ASSET__CG8bew6o__"